import OrganizationMcpLinkCreate from './OrganizationMcpLinkCreate'
import OrganizationMcpLinkEdit from './OrganizationMcpLinkEdit'

export default {
  create: OrganizationMcpLinkCreate,
  edit: OrganizationMcpLinkEdit,
}
